import React from "react";
import { Center, Spinner, Stack } from "@chakra-ui/react";
import useInfiniteScroll from "react-infinite-scroll-hook";

import Excerpt from "../News/Excerpt";
import { usePressOffice } from "@/hooks/usePress";
import { CloudType } from "@/types/cloud";
import { Website } from "@/types/website";

type Props = {
  website: Website;
  rounded?: boolean;
};

const Audio = ({ website }: Props): React.ReactElement => {
  const { articles, isLoading, hasNextPage, error, loadMore } = usePressOffice(
    website?.pressOffice?.id || website?.organization?.id,
    CloudType.AUDIO,
    !!website?.organization
  );
  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    disabled: !!error,
    loading: isLoading,
    onLoadMore: loadMore,
    rootMargin: "0px 0px 400px 0px",
  });

  return (
    <>
      <Stack spacing={3}>
        {(articles || [])?.map((article) => (
          <Excerpt
            key={`article-${article.id}`}
            article={article}
            website={website}
            rounded={false}
            lines={2}
          />
        ))}
      </Stack>
      {(isLoading || hasNextPage) && (
        <Center ref={sentryRef} mt="2">
          <Spinner />
        </Center>
      )}
    </>
  );
};

export default Audio;
